// Content for the Médailles Animaux final call to action.
// Dashboard values are illustrative demo data, shown only inside the interface mockup.
export type Bi = { fr: string; en: string }

export const ANIMALS_CTA_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/ef7f0193-7980-4ab7-9ae2-46e03d690859.jpg'

export const animalsCtaCopy = {
  eyebrow: { fr: 'Médailles et licences pour animaux ATNA', en: 'ATNA Pet Tags & Licences' },
  line1: { fr: 'Plus d’animaux', en: 'More pets' },
  line2: { fr: 'enregistrés.', en: 'registered.' },
  line3: { fr: 'Moins de gestion.', en: 'Less admin.' },
  primary: { fr: 'Demander une démo', en: 'Request a demo' },
  secondary: { fr: 'Parler à notre équipe', en: 'Talk to our team' },
  imageAlt: { fr: 'Un golden retriever souriant portant sa médaille', en: 'A smiling golden retriever wearing its tag' },
}

export const ctaDashboard = {
  title: { fr: 'Médailles et licences', en: 'Pet tags & licences' },
  nav: [
    { key: 'overview', label: { fr: 'Aperçu', en: 'Overview' } },
    { key: 'animals', label: { fr: 'Animaux', en: 'Animals' } },
    { key: 'licences', label: { fr: 'Licences', en: 'Licences' } },
    { key: 'payments', label: { fr: 'Paiements', en: 'Payments' } },
    { key: 'reminders', label: { fr: 'Rappels', en: 'Reminders' } },
    { key: 'reports', label: { fr: 'Signalements', en: 'Incident reports' } },
    { key: 'analytics', label: { fr: 'Rapports', en: 'Reports' } },
  ] as { key: 'overview' | 'animals' | 'licences' | 'payments' | 'reminders' | 'reports' | 'analytics'; label: Bi }[],
  kpis: [
    { key: 'registered', value: { fr: '12 482', en: '12,482' }, label: { fr: 'Animaux inscrits', en: 'Registered pets' }, note: null },
    { key: 'renew', value: { fr: '127', en: '127' }, label: { fr: 'À renouveler', en: 'To renew' }, note: { fr: '(30 prochains jours)', en: '(next 30 days)' } },
    { key: 'expired', value: { fr: '18', en: '18' }, label: { fr: 'Licences expirées', en: 'Expired' }, note: null },
  ] as { key: 'registered' | 'renew' | 'expired'; value: Bi; label: Bi; note: Bi | null }[],
  trendTitle: { fr: 'Évolution des licences', en: 'Licence trend' },
  months: { fr: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin'], en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'] },
  points: [20, 26, 32, 46, 50, 60],
  splitTitle: { fr: 'Répartition par statut', en: 'Status breakdown' },
  split: [
    { key: 'active', pct: 82, color: '#1F9D7A', label: { fr: 'Licences actives', en: 'Active' } },
    { key: 'renew', pct: 12, color: '#F2B233', label: { fr: 'À renouveler', en: 'To renew' } },
    { key: 'expired', pct: 6, color: '#E5484D', label: { fr: 'Licences expirées', en: 'Expired' } },
  ],
}

export const ctaJourney: { key: 'register' | 'pay' | 'remind' | 'find'; label: Bi }[] = [
  { key: 'register', label: { fr: 'Enregistrer', en: 'Register' } },
  { key: 'pay', label: { fr: 'Payer', en: 'Pay' } },
  { key: 'remind', label: { fr: 'Rappeler', en: 'Remind' } },
  { key: 'find', label: { fr: 'Retrouver', en: 'Reunite' } },
]
